import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<hr>\n")